import CONFIG from "@/app/config";
import axios from "axios";

export class AuthlessApiService {
  constructor() {
    this.client = axios.create({
      baseURL: CONFIG.EXPLORER_URL,
      headers: {
        "X-Axios-Instance": "authless",
        "X-Access-Token": "undefined",
      },
    });

    // Кастомная функция-обертка для обработки ошибок 503
    const custom503ErrorHandler = (error) => {
      // Проверяем статус 503
      if (error.response && error.response.status === 503) {
        // Получаем текущие параметры URL
        const currentUrl = new URL(window.location.href);
        const currentPath = currentUrl.pathname;
        // Разбираем путь на компоненты (удаляем начальный слеш, если есть)
        const pathParts = currentPath.replace(/^\/explorer\//, "").split("/");

        // Проверяем, что у нас есть хотя бы тип данных и сеть
        if (pathParts.length >= 2) {
          const network = pathParts[0]; // bitcoin, tron, и т.д.
          const type = pathParts[1]; // address, transaction, new-block
          const value = pathParts[2] || ""; // идентификатор (хеш, адрес)

          // Преобразуем тип для blockchair
          let blockchairType = type;
          if (type === "new-block") {
            blockchairType = "block";
          }

          // Формируем новый URL для blockchair в формате network/type/value
          let blockchairPath = `${network}/${blockchairType}/${value}`;

          // Создаем полный URL для перенаправления
          const redirectUrl = new URL(
            `https://blockchair.com/${blockchairPath}`,
          );

          // Копируем все параметры из текущего URL
          currentUrl.searchParams.forEach((value, key) => {
            redirectUrl.searchParams.append(key, value);
          });

          // Выполняем редирект
          window.location.href = redirectUrl.toString();
        } else {
          window.location.href = "https://blockchair.com/";
        }
        return Promise.reject(error);
      }
    };

    this.client.interceptors.response.use(
      (response) => response,
      custom503ErrorHandler,
    );
  }

  get(url, data, headers) {
    return this.client
      .get(url, { params: data, headers })
      .then((res) => Promise.resolve(res.data));
    // .catch(this._parseError);
  }

  post(url, data, headers) {
    return this.client
      .post(url, data, headers)
      .then((res) => Promise.resolve(res.data));
    // .catch(this._parseError);
  }

  put(url, data, headers) {
    return this.client
      .put(url, data, headers)
      .then((res) => Promise.resolve(res.data));
    // .catch(this._parseError);
  }

  patch(url, data, headers) {
    return this.client
      .patch(url, { params: data }, headers)
      .then((res) => Promise.resolve(res.data));
    // .catch(this._parseError);
  }

  delete(url, data, headers) {
    return this.client
      .delete(url, data, headers)
      .then((res) => Promise.resolve(res.data));
    // .catch(this._parseError);
  }
}

export default AuthlessApiService;
